<template>
  <div>   
    <embed
      src="https://gps.transplus.com"
      style="width:100%; height:calc(100vh - 76px) ;margin-top:76px; display: block;overflow: auto;"
    >
  </div>
</template>

<script>
  export default {
    mounted(){

    }
  }
</script>

<style>

</style>
